import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/useragreements', [
    {
      path: '',
      name: 'useragreement',
      component: () => import('@/views/user/UserAgreementList.vue'),
    },
    {
      path: '/create',
      name: 'useragreement-create',
      component: () => import('@/views/user/UserAgreementCreate.vue'),
    },
    {
      path: '/:id(\\d+)?',
      name: 'useragreement-edit',
      component: () => import('@/views/user/UserAgreementEdit.vue'),
    },
  ]);
};
